<div class="delivery-line" *ngIf="line" [class.expandedLine]="expanded" [class.readonly]="readonly">

    <!-- ///////////////////////////////////////////////////// MODE EDICIÓ -->
    <div class="edit-form" *ngIf="!readonly">

        <div class="lineNumber">{{ line.line }}</div>

        <div class="edit-rows">

            <!-- 1: quantitat i unitats -->
            <div class="edit-row">
                <div class="field quantity" *ngIf="columns.quantity">
                    <div class="subtitle">{{ 'DELIVERYLINE.QUANTITY.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.quantity" name="quantity" type="number" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field units" *ngIf="columns.units">
                    <div class="subtitle">{{ 'DELIVERYLINE.UNITS.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.units" name="units" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
            </div>

            <!-- 2: referència i descripció -->
            <div class="edit-row">
                <div class="field reference" *ngIf="columns.reference">
                    <div class="subtitle">{{ 'DELIVERYLINE.REFERENCE.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.reference" name="reference" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field description wide" *ngIf="columns.description">
                    <div class="subtitle">{{ 'DELIVERYLINE.DESCRIPTION.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.description" name="description" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
            </div>

            <!-- 3: preu unitat i preu total -->
            <div class="edit-row" *ngIf="columns.unitPrice || columns.totalPrice">
                <div class="field unitPrice" *ngIf="columns.unitPrice">
                    <div class="subtitle">{{ 'DELIVERYLINE.UNITPRICE.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.unitPrice" name="unitPrice" type="number" [step]="0.01"
                        autocomplete="off" (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field totalPrice" *ngIf="columns.totalPrice">
                    <div class="subtitle">{{ 'DELIVERYLINE.TOTALPRICE.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.totalPrice" name="totalPrice" type="number" [step]="0.01"
                        autocomplete="off" (valueChanged)="onValueChanged()"></input-component>
                </div>
            </div>

            <!-- 4: palets -->
            <div class="edit-row" *ngIf="columns.palletCount || columns.palletType">
                <div class="field palletCount" *ngIf="columns.palletCount">
                    <div class="subtitle">{{ 'DELIVERYLINE.PALLETCOUNT.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.palletCount" name="palletCount" type="number" [min]="0"
                        autocomplete="off" (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field palletType" *ngIf="columns.palletType">
                    <div class="subtitle">{{ 'DELIVERYLINE.PALLETTYPE.CAPTION' | translate }}</div>
                    <enum-selector [(ngModel)]="line.palletType" [enumvalues]="enumPalletTypes" name="palletType"
                        [translategroup]="'PALLETTYPES'" [showclosebutton]="false" (ngModelChange)="onValueChanged()">
                    </enum-selector>
                </div>
            </div>

            <!-- 5: pesos i litres -->
            <div class="edit-row" *ngIf="columns.kg || columns.netKg || columns.litres">
                <div class="field kg" *ngIf="columns.kg">
                    <div class="subtitle">{{ 'DELIVERYLINE.KG.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.kg" name="kg" type="number" [min]="0" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field netKg" *ngIf="columns.netKg">
                    <div class="subtitle">{{ 'DELIVERYLINE.NETKG.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.netKg" name="netKg" type="number" [min]="0" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field litres" *ngIf="columns.litres">
                    <div class="subtitle">{{ 'DELIVERYLINE.LITRES.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.litres" name="litres" type="number" [min]="0" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
            </div>

            <!-- 5b: caixes, bosses i sacs -->
            <div class="edit-row" *ngIf="columns.boxes || columns.bags || columns.sacks">
                <div class="field boxes" *ngIf="columns.boxes">
                    <div class="subtitle">{{ 'DELIVERYLINE.BOXES.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.boxes" name="boxes" type="number" [min]="0" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field bags" *ngIf="columns.bags">
                    <div class="subtitle">{{ 'DELIVERYLINE.BAGS.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.bags" name="bags" type="number" [min]="0" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field sacks" *ngIf="columns.sacks">
                    <div class="subtitle">{{ 'DELIVERYLINE.SACKS.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.sacks" name="sacks" type="number" [min]="0" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
            </div>

            <!-- 6: dimensions i volum -->
            <div class="edit-row" *ngIf="columns.wDimension || columns.yDimension || columns.hDimension || columns.m3">
                <div class="field wDimension" *ngIf="columns.wDimension">
                    <div class="subtitle">{{ 'DELIVERYLINE.WDIMENSION.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.wDimension" name="wDimension" type="number" [min]="0"
                        autocomplete="off" (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field yDimension" *ngIf="columns.yDimension">
                    <div class="subtitle">{{ 'DELIVERYLINE.YDIMENSION.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.yDimension" name="yDimension" type="number" [min]="0"
                        autocomplete="off" (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field hDimension" *ngIf="columns.hDimension">
                    <div class="subtitle">{{ 'DELIVERYLINE.HDIMENSION.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.hDimension" name="hDimension" type="number" [min]="0"
                        autocomplete="off" (valueChanged)="onValueChanged()"></input-component>
                </div>
                <div class="field m3" *ngIf="columns.m3">
                    <div class="subtitle">{{ 'DELIVERYLINE.M3.CAPTION' | translate }}</div>
                    <input-component [(ngModel)]="line.m3" name="m3" type="number" [min]="0" autocomplete="off"
                        (valueChanged)="onValueChanged()"></input-component>
                </div>
            </div>

            <!-- 7: paquet i etiquetes -->
            <div class="edit-row" *ngIf="columns.packageId || columns.userTags">
                <div class="field packageId" *ngIf="columns.packageId">
                    <div class="subtitle">{{ 'DELIVERYLINE.PACKAGE.CAPTION' | translate }}</div>
                    <entity-selector [(ngModel)]="line.packageId" [entitySelector]="'Package'" name="packageId"
                        [fixedFilterKeys]="packageFixedFilterKeys" [showgotomaintenance]="false"
                        (ngModelChange)="onValueChanged()"></entity-selector>
                </div>
                <div class="field userTags wide" *ngIf="columns.userTags">
                    <div class="subtitle">{{ 'DELIVERYLINE.USERTAGS.CAPTION' | translate }}</div>
                    <tags-chips [(ngModel)]="line.userTags" name="userTags" (valueChanged)="onValueChanged()">
                    </tags-chips>
                </div>
            </div>

            <!-- 7b: etiquetes públiques i privades -->
            <div class="edit-row" *ngIf="columns.publicTags || columns.privateTags">
                <div class="field publicTags wide" *ngIf="columns.publicTags">
                    <div class="subtitle">{{ 'DELIVERYLINE.PUBLICTAGS.CAPTION' | translate }}</div>
                    <tags-chips [(ngModel)]="line.publicTags" name="publicTags" (valueChanged)="onValueChanged()">
                    </tags-chips>
                </div>
                <div class="field privateTags wide" *ngIf="columns.privateTags">
                    <div class="subtitle">{{ 'DELIVERYLINE.PRIVATETAGS.CAPTION' | translate }}</div>
                    <tags-chips [(ngModel)]="line.privateTags" name="privateTags" (valueChanged)="onValueChanged()">
                    </tags-chips>
                </div>
            </div>

            <shared-delivery-line-batchinfo *ngIf="columns.batchInfo" [batchInfo]="line.batchInfo" [readonly]="false"
                [expectedBoxQuantity]="line.quantity" (addBatch)="onAddBatch()" (deleteBatch)="onDeleteBatch($event)"
                (valueChanged)="onBatchChanged()">
            </shared-delivery-line-batchinfo>

            <actions class="line-actions" [actionstrip]="lineActions" (clickAction)="onLineAction($event)"></actions>
        </div>
    </div>

    <!-- /////////////////////////////////////////////// MODE VISUALITZACIÓ -->
    <div class="view" *ngIf="readonly">

        <div class="first-line">
            <div class="value lineNumber">{{ line.line }}</div>
            <div class="value quantity" *ngIf="columns.quantity">{{ line.quantity | enter }}</div>
            <div class="value units" *ngIf="columns.units">{{ line.units }}</div>
            <div class="value reference" *ngIf="columns.reference">{{ line.reference }}</div>
            <div class="value description" *ngIf="columns.description">{{ line.description }}</div>
            <div class="value unitPrice" *ngIf="columns.unitPrice">{{ line.unitPrice | price }}</div>
            <div class="value totalPrice" *ngIf="columns.totalPrice">{{ line.totalPrice | price }}</div>
            <div class="value kg" *ngIf="columns.kg">
                <span class="prompt">{{ 'DELIVERYLINE.KG.CAPTION' | translate }}:</span> {{ line.kg | quantity }}
            </div>

            <div class="value button-sub-line" *ngIf="hasExpandableContent" (click)="onExpand()">
                <i aria-hidden="true" class="cercle fa"
                    [ngClass]="expanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
            </div>
        </div>

        <!-- Detall: prompt: valor, no camps. "---" quan no hi ha dada. -->
        <div class="second-line" *ngIf="expanded && hasExpandableContent">

            <div class="properties">
                <div class="property" *ngFor="let p of detailProperties">
                    <span class="prompt">{{ p.caption | translate }}:</span>
                    <span class="value">{{ p.value }}</span>
                </div>
            </div>

            <shared-delivery-line-batchinfo *ngIf="showDetail('batchInfo')" [batchInfo]="line.batchInfo"
                [readonly]="true" [expectedBoxQuantity]="line.quantity">
            </shared-delivery-line-batchinfo>
        </div>
    </div>

</div>